import { observer } from 'mobx-react';
import { T } from '../../../../../../../../../Translations';
import {
  filterGroups,
  filterParticipants,
  selectedParticipantCount,
} from '../../../../../../Functions';
import { SelectParticipantsState } from '../../../../Types';

export interface Props {
  state: SelectParticipantsState;
}

function ToBeAdded({ state }: Props) {
  return (
    <div>
      <div className="font-semibold text-sm pt-4">
        <T
          kind="Participants to be added ({{count}} selected)"
          count={selectedParticipantCount(
            filterGroups(state.newGroupsAndParticipants),
            filterParticipants(state.newGroupsAndParticipants),
          )}
        />
      </div>
    </div>
  );
}

export default observer(ToBeAdded);
